import * as React from 'react';

const emptyFn = function () { }

const validateArray = (state, isDirectValue) => {
    for (let i = 0; i < state.length; i++) {
        const value = state[i]
        if (!validateAll(value, isDirectValue)) {
            return false
        }
    }
    return true
}

export const validateAll = (state, isDirectValue) => {
    if (state?.valid) {
        return true
    }
    if (Array.isArray(state)) {
        return validateArray(state, isDirectValue)
    }
    let keys = Object.keys(state)
    for (let i = 0; i < keys.length; i++) {
        const value = state[keys[i]]
        if ((value && value.valid) || (value && isDirectValue)) {
            continue
        } else if (value && typeof value === "object" && !Array.isArray(value) && validateAll(value, isDirectValue)) {
            continue
        } else if (value && Array.isArray(value) && validateArray(value, isDirectValue)) {
            continue
        } else {
            return false
        }
    }
    return true
}

export const initValidationStates = (recievedState, funcName) => {
    let state = {}
    let setters = {}

    if (typeof recievedState !== "object") {
        const temp = {
            [funcName]: () => {
                let defaultValue = false
                if (recievedState && typeof recievedState === "boolean") {
                    defaultValue = recievedState
                }
                const [valid, setValid] = React.useState(defaultValue)
                const [touched, setTouched] = React.useState(false)
                state = {
                    touched,
                    valid
                }
                setters = {
                    valid: setValid,
                    touched: () => {
                        setTouched(true)
                    }
                }
                return [state, setters]
            }
        }

        return temp[funcName]()
    }

    Object.keys(recievedState).forEach((key) => {
        const value = recievedState[key]
        if (key !== '__noNesting') {
            if (!recievedState.__noNesting && value && typeof value === "object" && !Array.isArray(value)) {
                const [newState, newSetters] = initValidationStates(value)
                state[key] = {
                    ...newState,
                }
                setters[key] = {
                    ...newSetters,
                }
            } else {
                let defaultValue = false
                if (value && typeof value === "boolean") {
                    defaultValue = value
                }
                if (key === 'comment') {
                    defaultValue = true;
                }
                const [valid, setValid] = React.useState(defaultValue)
                const [touched, setTouched] = React.useState(false)
                state[key] = {
                    touched,
                    valid
                }
                setters[key] = {
                    valid: setValid,
                    touched: () => {
                        setTouched(true)
                    }
                }
            }
        }
    })

    return [state, setters]
}

export const syncState = (state, setters, defaultValue) => {
    Object.keys(setters).forEach((key) => {
        const setter = setters[key]
        if (setter && typeof setter === "object" && !Array.isArray(setter)) {
            syncState(state[key], setter[key])
        } else {
            setter(state[key] || defaultValue)
        }
    })
}

export const initState = (funcName, isValidationsObj) => {
    const func = {
        [funcName]: (hybridState, cb = emptyFn, targetKey = "value", args = [], effectsArr = []) => {
            let state = {}
            let setters = {}
            let handlers = {}
            let newArgs = [...args]
            let keys = Object.keys(hybridState)

            keys.forEach((key) => {
                if (key !== '__noNesting') {
                    const value = hybridState[key]
                    if (!hybridState.__noNesting && !isValidationsObj && value && typeof value === "object" && !Array.isArray(value)) {
                        args.push(key)
                        const [newState, newSetters, newHandler] = func[funcName](value, cb, targetKey, args, effectsArr)
                        state[key] = {
                            ...newState
                        }
                        setters[key] = {
                            ...newSetters
                        }
                        handlers[key] = {
                            ...newHandler,
                        }
                        args.pop()
                    } else if (isValidationsObj) {
                        const [newValue, newSetters] = initValidationStates(value || key, funcName)
                        state[key] = newValue
                        setters[key] = newSetters
                    }
                    else {
                        const [tempState, tempSetter] = React.useState(value)
                        effectsArr.push(tempState)
                        state[key] = tempState
                        setters[key] = (value) => {
                            tempSetter(value)
                            cb(value, key, ...newArgs)
                        }
                        handlers[key] = (e) => {
                            const value = e.target[targetKey]
                            tempSetter(e.target[targetKey])
                            cb({ e, value, fromHandler: true }, key, ...newArgs)
                        }
                    }
                }
            })

            if (!effectsArr.length && !isValidationsObj) {
                const temp = {
                    [funcName]: () => React.useState(hybridState)
                }
                return temp[funcName]()
            }

            return [state, setters, handlers, effectsArr]
        }
    }
    return func[funcName]
}

export default initState